import Footer from '../home/Footer';

const VirtualDJHowTo = () => {
  return (
    <div>
        <div className={'infoPage'}>
      <h1>How to broadcast with VirtualDJ for free</h1>
        <p>
            Coming soon...
        </p>
        </div>
        <Footer/>
    </div>
  );
};

export default VirtualDJHowTo;
